import { logger } from '../../utils/logger'
import { Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'
import { Observable, of } from 'rxjs'
import { catchError, map } from 'rxjs/operators'
import { GestaoUsuarioService } from 'src/app/services/gestao-usuario.service'
import { UnespCoreAuthService } from 'src/libs/unesp-core'

@Injectable({ providedIn: 'root' })
export class GestaoUsuarioCtuGuard implements CanActivate {
  constructor(
    private gestaoUsuarioService: GestaoUsuarioService,
    private unespCoreAuthService: UnespCoreAuthService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> {
    if (this.unespCoreAuthService.hasPermissionBasedRoles(['SUPERADMIN'])) {
      return of(true)
    }

    return this.gestaoUsuarioService.verificarAcesso().pipe(
      map(permitido => {
        logger.log('Verificação CTU:', permitido ? 'Usuário é CTU' : 'Usuário NÃO é CTU')
        if (!permitido) {
          this.router.navigate(['access-denied'])
        }
        return permitido
      }),
      catchError(() => {
        this.router.navigate(['access-denied'])
        return of(false)
      })
    )
  }
}
